import React from 'react';
import history from 'app/routes/history';
import IActions from 'app/types/actions';

import { ITeamsSelector, IClubsSelector } from 'app/types/selector';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import TeamsTable from 'app/components/teams/TeamsTable';
import TeamRow from 'app/components/teams/TeamRow';

interface IManageClubTeamsProps {
  appReady: boolean;
  clubs: IClubsSelector;
  teams: ITeamsSelector;
  actions: IActions;
}

export default class ManageClubTeams extends React.Component<
  IManageClubTeamsProps,
  {}
> {
  static defaultProps = {
    appReady: false,
    clubs: {},
    teams: {},
    actions: undefined,
  };

  componentDidMount(): void {
    this.props.actions.getAllTeams(
      {
        filter: { 'club-id': this.props.clubs.currentClubId },
      },
      false,
    );
  }

  componentDidUpdate(prevProps): void {
    // if (this.props.teams.hasLoaded && this.props.teams.teamIds.length === 0) {
    //   history.push('/create-team');
    // }
  }

  handleCreate = (e): void => {
    e.preventDefault();
    history.push('/create-team');
  };

  render(): React.ReactNode {
    const { teamsById, teamIds } = teamsSelectors.getTeamsFilteredByClubById(
      this.props.teams.teamsById,
      this.props.clubs.currentClubId,
    );
    return (
      <div className="h-100 m-h-100">
        <div className="row">
          <div className="col">
            <TeamsTable
              {...this.props.teams}
              teamsById={teamsById}
              teamIds={teamIds}
              actions={this.props.actions}
              appReady={this.props.appReady}
              persistentFilterConfig={{
                clubId: this.props.clubs.currentClubId,
              }}
              selectTeam={this.props.actions.selectTeam}
              handleCreate={this.handleCreate}
            />
            {/* <Card className="">
              <div className="row card-title">
                <div className="col col-6 col-md-8 card-title-col">
                  <span>Select Team</span>
                </div>
                <div className="col col-6 col-md-4 btn-flex-group">
                  <div className="btn-flex-container">
                    <Button
                      className="btn-thinner btn-thin-margin btn-success"
                      isLoading={this.props.teams.isLoading}
                      onClick={this.handleCreate}
                    >
                      Create Team
                    </Button>
                  </div>
                </div>
              </div>
              <div className="row head-row">
                <div className="col col-6">Name</div>
                <div className="col col-6" />
              </div>
              <Tbody name="teams">{this.renderTeamList()}</Tbody>
            </Card> */}
          </div>
        </div>
      </div>
    );
  }
}
